/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState, useRef } from 'react';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { ShopContext } from '../../data/shop/ShopConf';
import { getConfiguration } from '../../data/utils/configuration';
import { getSimpleKeyboardLayout } from '../../data/utils/getSimpleKeyboardLayout';
import { labels } from '../../data/labels';
import ReservationHistory from './ReservationHistory';
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

function ReservationBox(props) {
	const betslipContext = useContext(BetslipContext);
    const shopContext = useContext(ShopContext);
    const conf = getConfiguration();
    const [reservationCode, setReservationCode] = useState('');
    
    const usageMode = window.appConfig.usageMode;
    const keyboardEnabled = usageMode && usageMode.indexOf('touch') >= 0;

    const [virtualKeyboardShown, setVirtualKeyboardShown] = useState(false);
    const [virtualKeyboardLayout, setVirtualKeyboardLayout] = useState('default');
    const keyboardRef = useRef(null);

    function showVirtualKeyboard(){
    	setVirtualKeyboardShown(true && keyboardEnabled);
    }
    function hideVirtualKeyboard(){
    	setVirtualKeyboardShown(false);
    }
    
    function toggleVirtualKeyboard(){
    	if(virtualKeyboardShown){
    		hideVirtualKeyboard();
    	}
    	else{
    		showVirtualKeyboard();
    	}
    }

    function toggleVirtualShift(){
    	const newLayout = virtualKeyboardLayout === 'default' ? 'shift' : 'default';
    	setVirtualKeyboardLayout(newLayout);
    }

    function onKeyPressedVirtualKeyboard(key){
        if(key === '{enter}'){
            loadTicket();
            hideVirtualKeyboard();
            return;
        }
    	(key === '{shift}' || key === '{lock}') && toggleVirtualShift();
    }


    function handleChangeVirtualKeyboard(value){
    	if(value.indexOf('Clear.') >= 0){
    		setReservationCode('');
    		keyboardRef.current.setInput('');
    	}
    	else{
        	setReservationCode(value);
    	}
    }

    function loadTicket() {
   		if(reservationCode && reservationCode.length > 0){
	    	betslipContext.reloadReservedTicket(reservationCode);    	
    	}
    }

    function handleChange(value){
        setReservationCode(value);
        if(keyboardRef.current){
            keyboardRef.current.value = value;
        }    
    }
	const couponKey = props.couponKey;
    let reservations = betslipContext.getReservations() || [];
    
    const fastbetAliasEnabled = shopContext.enabled && conf.fbt === 'XR';

    return (
        <div id="tab-prenotazioni" className={fastbetAliasEnabled? 'adj-margin-top' : ''}>
            <div className="padding-orizzontale padding-verticale text-center">
                {
                	!window.appConfig.TERMINAL_AGENCY && (
                        <p className="disclaimerReservation">
                        	{labels['betslip.reservation.disclaimer_part1'].replaceAll('{{DAYS}}', conf.rps?.edr || 3)} 
                        	{labels['betslip.reservation.disclaimer_part2']}
                        </p>
                	)
                }

                <br />
                <p className="reservationInputLabel">{labels['betslip.reservation.label_part1']} <span className={"grassetto"}>{couponKey}</span> {labels['betslip.reservation.label_part2']}</p>
                <div className="input-widget">
                    <input className="input-personalizzato" 
                           type="text" 
                           id="input-reservation-box-coupon-1" 
                           placeholder={labels['betslip.reservations.code']} 
                           value={reservationCode} 
                           onClick={() => {toggleVirtualKeyboard()}}
                           onChange={e => handleChange(e.target.value + '')} autoFocus />
                    <a className="bottone bg-colore-1 bianco" onClick={() => loadTicket()}>{labels['betslip.reservations.load']}</a>
                </div>
                {
                    virtualKeyboardShown && 
                    <div className="virtual-keyboard-container">
                            <Keyboard onKeyPress={onKeyPressedVirtualKeyboard}
                                    keyboardRef={r => (keyboardRef.current = r)} 
                                    layout={getSimpleKeyboardLayout()} 
                                    layoutName={virtualKeyboardLayout} 
                                    onChange={handleChangeVirtualKeyboard} />
                    </div>
                }

                {reservations.length > 0 &&
                    <ReservationHistory reservations={reservations} />
                }
            </div>
        </div>
   );
}

export default ReservationBox;